import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/logo.svg';
const _withScopeId = n => (_pushScopeId("data-v-06d9d733"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "auth"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "wrap"
};
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"slogan-wrap\" data-v-06d9d733><div class=\"slogan-header\" data-v-06d9d733><img class=\"logo\" src=\"" + _imports_0 + "\" data-v-06d9d733><span class=\"line\" data-v-06d9d733>/</span><span class=\"desc\" data-v-06d9d733>让商业变得更智慧</span></div></div>", 1);
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "state"
}, [/*#__PURE__*/_createElementVNode("span", null, "登录即表示同意"), /*#__PURE__*/_createElementVNode("span", {
  class: "state-item"
}, "《注册协议》"), /*#__PURE__*/_createElementVNode("span", {
  class: "state-item"
}, "《个人信息处理规则》")], -1));
export function render(_ctx, _cache) {
  const _component_router_view = _resolveComponent("router-view");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_router_view), _hoisted_5])])]);
}